import React, { useState } from 'react';
import type { MenuProps } from 'antd';
import Icon, { UserOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import ModalExit from '@/components/ModalExit/index.jsx';
import { LogoutIconSvg, OrganizationIconSvg } from '@/assets/svg';
import { DropdownMenu } from '@hydrodigital/design-system';
import { ChevronDownIcon, UserAvatarMaskDataUrl } from '@/layout/DashboardLayout/Icons';

const Header: React.FC = ({ security }: any) => {
	const name = `${security.firstname} ${security.lastname}`;
	const navigate = useNavigate();
	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const iconMap: any = {
		user: <UserOutlined rev={undefined} />,
		team: <TeamOutlined rev={undefined} />,
		org: <Icon component={OrganizationIconSvg} rev={undefined} />,
		logout: <Icon component={LogoutIconSvg} rev={undefined} />,
	};
	const roleConfig: any = {
		Operator: [
			{ type: 'item', label: 'Log Out', icon: 'logout', destructive: true, action: 'logout' },
		],
		Administrator: [
			// { type: 'item', label: 'My Profile', icon: 'user', route: '/users' },
			{ type: 'item', label: 'User Manager', icon: 'team', route: '/users' },
			{ type: 'separator' },
			{ type: 'item', label: 'Log Out', icon: 'logout', destructive: true, action: 'logout' },
		],
		SuperAdmin: [
			//{ type: 'item', label: 'My Profile', icon: 'user', route: '/users' },
			{ type: 'item', label: 'User Manager', icon: 'team', route: '/users' },
			{ type: 'item', label: 'Organization Manager', icon: 'org', route: '/organizations' },
			{ type: 'separator' },
			{ type: 'item', label: 'Log Out', icon: 'logout', destructive: true, action: 'logout' },
		],
	};
	const renderDropdownItems = () => {
		const defs = roleConfig[security.role] || roleConfig.Operator;
		return defs.map((d: any, idx: number) => {
			if (d.type === 'separator') {
				return <DropdownMenu.Separator key={`sep-${idx}`} />;
			}
			return (
				<DropdownMenu.Item
					key={`item-${idx}`}
					icon={iconMap[d.icon]}
					destructive={!!d.destructive}
					onSelect={() => {
						if (d.action === 'logout') {
							setShowLogoutModal(true);
						} else if (d.route) {
							navigate(d.route);
						}
					}}
				>
					{d.label}
				</DropdownMenu.Item>
			);
		});
	};
	return (
		<div
			style={{
				height: '72px',
				display: 'flex',
				flexDirection: 'row-reverse',
				alignItems: 'center',
			}}
		>
			<DropdownMenu>
				<DropdownMenu.Trigger>
					<div
						className="flex items-center justify-between"
						style={{
							height: 32,
							borderRadius: 20,
							padding: '0 12px',
							backgroundColor: 'white',
							color: '#434B56',
							border: '1px solid #75798f',
						}}
					>
						<span
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								marginRight: 8,
								transform: 'none',
								transition: 'none',
							}}
						>
							<span
								style={{
									width: 16,
									height: 16,
									display: 'inline-block',
									backgroundColor: 'currentColor',
									WebkitMaskImage: UserAvatarMaskDataUrl,
									WebkitMaskRepeat: 'no-repeat',
									WebkitMaskSize: 'contain',
									maskImage: UserAvatarMaskDataUrl,
									maskRepeat: 'no-repeat',
									maskSize: 'contain',
								}}
							/>
						</span>
						<span style={{ fontSize: 12 }}>{name}</span>
						<ChevronDownIcon />
					</div>
				</DropdownMenu.Trigger>
				<DropdownMenu.Content width={200}>{renderDropdownItems()}</DropdownMenu.Content>
			</DropdownMenu>
			{showLogoutModal && <ModalExit closeModal={setShowLogoutModal} />}
		</div>
	);
};

function mapState(state: any) {
	return {
		security: state.security.array,
	};
}

export default connect(mapState)(Header);
